import {NavigationElement} from "../../../types/navigation";
import {ROUTES} from "../../../utils/consts/router";
import {RxDashboard} from "react-icons/rx";
import {styled} from "@chakra-ui/react";
import {useNavigate} from "react-router-dom";
import {FaRegFolderOpen} from "react-icons/fa";
import {HiOutlineUserGroup} from "react-icons/hi";
import {RiFolderUserLine} from "react-icons/ri";
import {TbBuildingFactory2} from "react-icons/tb";

const Navigation = styled("div", {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginTop: "40px",
  }
})

const Element = styled("div", {
  baseStyle: {
    height: "40px",
    display: "flex",
    color: "#fff",
    alignItems: "center",
    fontFamily: "Mabry Pro",
    fontWeight: "normal",
    fontSize: "15px",
    cursor: "pointer",
    marginLeft: "10px",
  }
})

const Icon = styled("div", {
  baseStyle: {
    marginRight: 2,
  }
})

const navigationElements: NavigationElement[] = [
  {
    title: "Dashboard",
    icon: <RxDashboard style={{width: 16, height: 16}}/>,
    path: ROUTES.HOME_CHILD,
  },
  {
    title: "Missions",
    icon: <FaRegFolderOpen style={{width: 16, height: 16}}/>,
    path: ROUTES.MISSIONS_CHILD,
  },
  {
    title: "Clients",
    icon: <HiOutlineUserGroup style={{width: 16, height: 16}}/>,
    path: ROUTES.CUSTOMERS_CHILD,
  },
  {
    title: "Membres",
    icon: <RiFolderUserLine style={{width: 16, height: 16}}/>,
    path: ROUTES.USERS_CHILD,
  },
  {
    title: "Ma Junior",
    icon: <TbBuildingFactory2 style={{width: 16, height: 16}}/>,
    path: ROUTES.COMPANY_CHILD,
    path_child: [
      ROUTES.COMPANY_GENERAL,
      ROUTES.COMPANY_CUSTOM,
      ROUTES.COMPANY_ADMIN,
      ROUTES.COMPANY_GROUPS,
      ROUTES.COMPANY_RANKS,
      ROUTES.COMPANY_POLES,
      ROUTES.COMPANY_JOBS
    ]
  }
]

function OverlayNavigation() {

  const navigate = useNavigate();

  return (
    <Navigation>
      {navigationElements.map((element, index) => {

        const current = window.location.pathname === element.path || element.path_child?.includes(window.location.pathname);

        return (
          <Element key={index} onClick={() => navigate(element.path)}>
            <Icon
              style={{
                color: current ? "#2B2A24" : "#54524A",
              }}
            >
              {element.icon}
            </Icon>
            <div style={{
              color: current ? "#2B2A24" : "#54524A",
              textUnderlineOffset: "3px",
              textUnderlinePosition: "under",
              textDecoration: "underline",
              textDecorationColor: current ? "#54524A" : "transparent",
              textDecorationThickness: "0.1rem",
            }}
            >
              {element.title}
            </div>
          </Element>
        )
      })}
    </Navigation>
  )
}

export default OverlayNavigation;